<template>
    <div class="password-input" :style="cssVars">
        <input
            :type="passwordFieldType"
            :class="['totem-input', size, { 'error': hasError }]"
            @input="handleInput"
            :disabled="disabled"
            :value="value"
            v-bind="$attrs"
        >
        <label :class="['password-input__label', { 'required': isRequired } ]" v-html="label"></label>
        <span :class="['input-icon', passwordIconClass]" @click="switchPasswordVisibility"></span>
    </div>
</template>

<script>
    export default {
        name: 'totem-password-input',
        props: {
            value: String,
            size: {
                type: String,
                validator: (prop) => ['small', 'medium', 'large'].includes(prop),
                default: 'medium'
            },
            width: {
                type: Number
            },
            fullWidth: Boolean,
            disabled: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: ''
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            hasError: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                passwordFieldType: 'password'
            }
        },
        methods: {
            handleInput ($event) {
                this.$emit('input', $event.target.value)
            },
            switchPasswordVisibility () {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            }
        },
        computed: {
            cssVars () {
                if (this.width != null) {
                    return { '--width': this.width + 'px' }
                } else if (this.fullWidth) {
                    return { '--width': '100%' }
                }
                return { '--width': '264px' }
            },
            passwordIconClass () {
                return this.passwordFieldType === 'password' ? 'icon-eye' : 'icon-eye-blocked'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .password-input {
        position: relative;
        width: var(--width);

        &__label {
            font-family: PlusJakartaSans-Bold, sans-serif;
            font-size: 1rem;
            letter-spacing: 1.5px;
            color: $lavender;
            text-transform: uppercase;
            position: absolute;
            top: 10px;
            left: 20px;

            &.required {
                &:after {
                    content: ' *';
                }
            }
        }
        }

    .totem-input {
        font-family: PlusJakartaSans-Light, sans-serif;
        border: 1px solid $lavender;
        padding: 16px 20px 3px 20px;
        border-radius: 10px;
        color: $black;
        width: 100%;

        &.small {
            font-size: 1.3rem;
            height: 30px;
        }

        &.medium {
            font-size: 1.6rem;
            height: 50px;
        }

        &:disabled {
            background: $alabaster;
        }

        &.error {
            border: 1px solid $chestnut;
        }
    }

    .input-icon {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 18px;
        color: $lavender;
    }
</style>
